import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconComponent, IconName, RadioComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-churn-flow-reason-selectable-card',
  templateUrl: './churn-flow-reason-selectable-card.component.html',
  styleUrls: ['./churn-flow-reason-selectable-card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, RadioComponent],
})
export class ChurnFlowReasonSelectableCardComponent {
  public iconName = input.required<IconName>();
  public label = input.required<string>();
  public description = input.required<string>();
  public isSelected = input<boolean>(false);
  public displayInputIfSelected = input<boolean>(false);
}
